import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames/bind';

import Button from 'components/App/Button';

import { ReactComponent as CheckedMarkSuccess } from 'assets/images/location/checked_mark_success-svg.svg';
import images from 'assets/images';

import styles from './ModalConfirmDiscoverProvince.module.scss';

const cx = classNames.bind(styles);

function ModalConfirmDiscoverProvince(props) {
  const {
    isOpen,

    onCloseModal,
    onAddDiscoveryPlace,
  } = props;

  return (
    <Modal
      className={cx('ModalOverplay')}
      isOpen={isOpen}
      toggle={onCloseModal}
      contentClassName={cx('Modal')}
      style={{ maxWidth: '779px' }}
    >
      <ModalBody className={cx('ModalBody')}>
        <Button isDefault classes={cx('Button__Close')} onClick={onCloseModal}>
          <img
            src={images.modalClose.default}
            alt=""
            className="img-fluid img-close"
          />
        </Button>

        <CheckedMarkSuccess className={cx('Checkmark')} />

        <div>
          <h3 className={cx('Title')}>
            Bạn đã tạo điểm đến thành công
          </h3>

          <p className={cx('Description')}>
            Thêm điểm khám vào vào điểm đến để xây dựng nội dung hoàn chỉnh cho điểm đến
          </p>
        </div>
      </ModalBody>

      <ModalFooter className={cx('ModalFooter')}>
        <button type="button" className={cx('Button__Cancel')} onClick={onCloseModal}>
          Huỷ
        </button>
        <Button
          type="button"
          className={cx('Button__Add')}
          onClick={onAddDiscoveryPlace}
        >
          Thêm điểm khám phá
        </Button>
      </ModalFooter>
    </Modal>
  );
}

ModalConfirmDiscoverProvince.propTypes = {
  isOpen: PropTypes.bool.isRequired,

  onCloseModal: PropTypes.func,
  onAddDiscoveryPlace: PropTypes.func,
};

ModalConfirmDiscoverProvince.defaultProps = {
  onCloseModal: () => { },
  onAddDiscoveryPlace: () => { },
};

export default React.memo(ModalConfirmDiscoverProvince);
